import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils, getNoDataForBuildCacheCharts } from '@/views/dashboard/dashboard.charts.utils';
import { useAgentsPageQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import buildCacheCoreUsageChart from './build-cache-core-usage-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-cache-core-usage-chart-controller',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);

const GQL_AgentsPageQuery = useAgentsPageQuery(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));
const dashboardChartUtils = useDashboardChartUtils();
const dashboard = useDashboard();
const buildCacheCoreUsageChartConfig = dashboard.gridUtilization.buildCacheCoreUsageChart;
const options = computed(() => ({
  ...buildCacheCoreUsageChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: buildCacheCoreUsageChartConfig,
        chartId: buildCacheCoreUsageChartConfig.value.chartId,
        componentInstance: buildCacheCoreUsageChart,
      }),
    },
  },
}));

const noData = computed(() =>
  getNoDataForBuildCacheCharts(
    GQL_AgentsPageQuery?.result?.value?.ibManagerEntities?.licenseMetadata?.hasBuildCache || false,
    dashboard.metadata.value.gridUtilization.noData.buildCacheCoreUsageChart,
  ),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(buildCacheCoreUsageChart, {
    "chart-options": {
      ..._unref(buildCacheCoreUsageChartConfig),
      options: _unref(options),
    },
    "no-data": _unref(noData)
  }, null, 8, ["chart-options", "no-data"]))
}
}

})